import { camelCase, isString, kebabCase } from 'lodash-es';

import { EPageWidth } from '../constants';

/**
 * 样式转换为对象
 *
 * @param style 样式字符串或者样式对象
 * @returns 转换后的样式对象
 */
export const styleObjectToString = function (style: string | Record<string, string>) {
  if (typeof style === 'string') {
    return style;
  }

  return Object.keys(style).map(key => `${kebabCase(key)}: ${style[key]}`)
    .join(';');
};

/**
 * 根据页面类型返回页面宽度
 *
 * @param pageType 页面类型
 *
 * @returns 页面宽度
 */
export function getPageWidth(pageType: string) {
  return ['Hippy-TV', 'TV'].includes(pageType) ? EPageWidth.tv : EPageWidth.normal;
}

// #region styleStringToObject
/**
 * 样式转换为对象
 *
 * @param style 样式字符串或者样式对象
 * @returns 转换后的样式对象
 */
export const styleStringToObject = function (style: string | Record<string, string | number>) {
  if (!isString(style)) {
    return style;
  }

  const styleObj: Record<string, string> = {};

  style.split(';').forEach((styleLine) => {
    if (!styleLine) {
      return;
    }
    const [key = '', value = ''] = styleLine.split(':').map(value => value.trim());
    styleObj[camelCase(key)] = value;
  });

  return styleObj;
};

export function addClass(el: HTMLElement, className = '') {
  if (!el || !className) {
    return;
  }

  const classes = className.split(' ');

  classes.filter(className => !!className)
    .forEach((className) => {
      el.classList.add(className);
    });
};

export function removeClass(el: HTMLElement, className = '') {
  if (!el || !className) {
    return;
  }

  const classes = className.split(' ');

  classes.filter(className => !!className)
    .forEach((className) => {
      el.classList.remove(className);
    });
};

export function hasClass(el: HTMLElement, className = '') {
  if (!el || !className) {
    return false;
  }

  if (className.indexOf(' ') > -1) {
    throw new Error('className should not contain space.');
  }

  return el.classList.contains(className);
};


// #endregion

// #endregion

// #region transformStyle
/**
 * 转换组件的样式
 *
 * @param style 样式对象或者样式字符串
 * @returns
 */
export function transformStyle(style: any) {
  if (!style) {
    return {};
  }

  const styleObj = isString(style) ? styleStringToObject(style) : { ...style };

  const results: Record<string, any> = {};
  Object.entries(styleObj).forEach(([key, value]) => {
    if (key === 'backgroundImage') {
      value && (results[key] = fillBackgroundImage(value as string));
      return;
    }

    if (key === 'transform' && !isString(value)) {
      results[key] = getStyleTransformValue(value as Record<string, any>);
      return;
    }

    if (!styleTransparentWhiteList.includes(key) && value && isNumberString(value as string)) {
      results[key] = transformStyleValueToRem(value);
      return;
    }

    results[key] = value;
  });

  return results;
}

const styleTransparentWhiteList = ['zIndex', 'opacity', 'fontWeight'];

/**
 * 将样式值转换成 rem 单位
 *
 * @param styleValue 样式值
 * @returns
 */
export function transformStyleValueToRem(styleValue: any) {
  return `${Number(styleValue) / 100}rem`;
}

/**
 * 转换 style 中的 `transform`
 *
 * @param value
 * @returns
 */
function getStyleTransformValue(value: Record<string, any>) {
  if (!value) {
    return '';
  }

  return Object.entries(value)
    .map(([transformKey, transformValue]) => {
      const defaultValue = transformKey === 'scale' ? 1 : 0;
      return `${transformKey}(${transformValue || defaultValue})`;
    })
    .join(' ');
};

/**
 * 是否数字字符串
 *
 * 包括: 负数/小数
 *
 * @param str 字符串
 * @returns 是否数字字符串
 */
const isNumberString = (str: string) => /^[-]?[0-9]*[.]?[0-9]*$/.test(str);

/**
 * 处理背景图片值
 *
 * @param value 背景图片数值
 * @returns 处理后的背景图片值
 */
const fillBackgroundImage = (value: string) => {
  if (value && !/^url/.test(value) && !/^linear-gradient/.test(value)) {
    return `url(${value})`;
  }
  return value;
};
